export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_2.ab72a0ea.jpg";